var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-breadcrumb',{attrs:{"separator":"/"}},[_c('el-breadcrumb-item',{attrs:{"to":{ path: '/course' }}},[_vm._v("我的课程")]),_c('el-breadcrumb-item',{attrs:{"to":{ path: '/course/courselist' }}},[_vm._v(" "+_vm._s(_vm.coursename)+" ")]),_c('el-breadcrumb-item',{attrs:{"to":{ path: _vm.link }}},[_vm._v(" "+_vm._s(_vm.$props.name)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }